import React, { Component } from "react";
import { Link, navigate } from "@reach/router";
import { connect } from "react-redux";
import Search from "./Search";
import Auth from "Api/Auth";
function mapStateToProps(state) {
  return {
    section: state.section,
    showSearchWidgetIn: state.showSearchWidgetIn,
  };
}
class SideBar extends Component {
  constructor(props) {
    super(props);
    this.clicked = (to) => {
      navigate(to);
      this.props.dispatch({ type: "showSidebar", payload: false });
    };
    this.logout = () => {
      Auth.LogoutUser();
      navigate("/");
    };
  }
  render() {
    return (
      <div
        className="sidebar"
        data-color="purple"
        data-background-color="white"
      >
        <div className="logo">
          <a href="/" className="simple-text logo-normal">
            Venture Garage
          </a>
        </div>
        <div className="sidebar-wrapper">
          {this.props.showSearchWidgetIn.includes(this.props.section) ? (
            <Search />
          ) : null}
          <ul className="nav navbar-nav nav-mobile-menu">
            <li className="nav-item dropdown">
              <a
                className="nav-link"
                href="#pablo"
                id="navbarDropdownProfile"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="material-icons">person</i>
                <p className="d-lg-none d-md-block">Account</p>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdownProfile"
                style={{ transform: "unset !important" }}
              >
                {Auth.decodedToken().moderator ? null : (
                  <Link to="user" className="dropdown-item">
                    Profile
                  </Link>
                )}

                <a className="dropdown-item" onClick={this.logout} href>
                  Log out
                </a>
              </div>
            </li>
          </ul>
          <ul className="nav">
            {(this.props.links || []).map((link, index) => {
              const { to, icon, display_name, visibleTo = [] } = link;
              if (visibleTo.includes(Auth.decodedToken().group)) {
                return (
                  <li
                    key={link.to}
                    className={`nav-item pointer ${
                      this.props.section === display_name ? "active" : ""
                    }`}
                  >
                    <a
                      className="nav-link"
                      onClick={() => {
                        this.clicked(to);
                      }}
                      href={to}
                    >
                      <i className="material-icons">{icon}</i>
                      <p>{display_name}</p>
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(SideBar);
